import { PageContext } from './pageContext';

export const isEnterprisePage = (headers: PageContext) => {
  const { subdomain, path } = headers;

  return subdomain.includes('enterprise') || path.startsWith('/enterprise');
};

export const rewriteEnterpriseSlug = (slug: string) => {
  if (!slug) return '';
  return slug.trim().replace(/^enterprise(?:\/)?/, '');
};
